module.exports = __webpack_public_path__ + "img/manage-4.6cb8a849.png";